import { render, staticRenderFns } from "./SystemUpdate.vue?vue&type=template&id=b317b5ac&scoped=true&"
import script from "./SystemUpdate.vue?vue&type=script&lang=js&"
export * from "./SystemUpdate.vue?vue&type=script&lang=js&"
import style0 from "./SystemUpdate.vue?vue&type=style&index=0&id=b317b5ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b317b5ac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
